import styled from '@emotion/styled'
import tw from 'twin.macro'

export const Wrapper = styled('div')`
  ${tw`relative cursor-pointer`}

  ${({ isMapPin, pinHeight, pinWidth }) =>
    isMapPin ? `bottom: ${pinHeight}px; left: -${pinWidth / 2}px;` : ''}
`
